import React from 'react'
import { useIntl } from 'react-intl'
import { Table } from '@contrast-security-inc/design-system-tables'
import { RouteContext } from '../route-provider'
import { useApplicationPolicies } from './api/use-application-policies'

const useOrgAppUuids = () => {
  const {
    parameters: [orgUuid, _, appUuid]
  } = React.useContext(RouteContext)

  return {
    orgUuid,
    appUuid
  }
}

// pull ids from route for now since this is still in angular land
export const AppPolicyTable = (/*{ orgUuid, appUuid }*/) => {
  const intl = useIntl()
  const columns = React.useMemo(() => {
    return [
      {
        accessorKey: 'rule_title',
        header: intl.formatMessage({ id: 'title_rule' }),
        size: 436
      },
      {
        accessorKey: 'ruleSeverityLabel',
        header: intl.formatMessage({ id: 'title_severityLevel' }),
        size: 100
      },
      {
        accessorKey: 'rule_description',
        header: intl.formatMessage({ id: 'title_description' })
      },
      {
        accessorKey: 'qa_enabled',
        header: intl.formatMessage({
          id: 'title_serverEnvironmentQualityAssurance'
        }),
        size: 100
      },
      {
        accessorKey: 'dev_enabled',
        header: intl.formatMessage({
          id: 'title_serverEnvironmentDevelopment_abbreviation'
        }),
        size: 100
      },
      {
        accessorKey: 'prod_enabled',
        header: intl.formatMessage({
          id: 'title_serverEnvironmentProduction_abbreviation'
        }),
        size: 100
      }
    ]
  }, [intl])
  const { error, isLoading, data } = useApplicationPolicies(useOrgAppUuids())
  const hasError = !!(error || data?.success === false)

  return (
    <Table
      hasError={hasError}
      isLoading={isLoading}
      columns={columns}
      data={data?.configs || []}
      emptyStateProps={{
        headerText: intl.formatMessage({ id: 'detail_apiRequestError' }),
        bodyText: data?.messages[0] || ''
      }}
    />
  )
}

// Table Issues
// it should handle undefined as data prop so users do not have to fallback on every usage ex: || []
// pagination controls could use some padding on right and left edges
// allow undefined for emptyStateProps and hasError
